import cx from 'clsx';
import { TextLink, Type } from 'src/components/core';
import type { BlogPage } from '../../types/blogPage';
import { DocumentMetadata } from './metadata.component';

export interface DocumentSummaryProps {
  className?: string;
  document: BlogPage;
}

export function DocumentSummary({ className, document }: DocumentSummaryProps) {
  const subtitleText = document?.attributes?.short_description?.toString();

  return (
    <div className={cx('py-6', className)}>
      <Type
        component="h2"
        weight="font-semibold"
        variant="text-2xl"
        className="cursor-pointer"
      >
        {document.attributes.title}
      </Type>
      <DocumentMetadata
        document={document}
        containerClassName="mt-2"
        size="small"
      />
      <Type className="mb-6 mt-4" variant="text-sm">
        {subtitleText}
      </Type>
      <TextLink type="route">Read more →</TextLink>
    </div>
  );
}
